export default "__VITE_ASSET__CVpqios3__"